import React from "react";
import { makeStyles } from "@material-ui/core";
import clsx from "clsx";
import I18nText from "../../../../../../elements/I18nText";
import BubbleHelp from "../../../../../BubbleHelp";
import { DEVICE_TYPE } from "../../../../../../domain/device";
import LxIotHeader from "./LxIotHeader";

const useStyles = makeStyles(theme => ({
  row: {
    paddingBottom: 6
  },
  column: {
    paddingLeft: 12,
    fontSize: 13,
    fontWeight: theme.typography.fontWeightMedium,
    textAlign: "center"
  },
  color: {
    width: 30
  },
  isConnected: {
    width: 75
  },
  subType: {
    width: 100
  },
  name: {
    width: "66%"
  },
  contentType: {
    width: "34%"
  },
  capacity: {
    width: 175
  },
  fillLimit: {
    width: 110
  },
  threshold: {
    width: 110
  },
  temperatureLimit: {
    width: 100
  }
}));

const Header = ({ showTemperatureColumn, deviceType }) => {
  const classes = useStyles();

  if (deviceType === DEVICE_TYPE.LX_IOT) {
    return <LxIotHeader showTemperatureColumn={showTemperatureColumn} />;
  }

  return (
    <thead>
      <tr className={classes.row}>
        <th className={classes.color}></th>
        <th className={clsx(classes.isConnected, classes.column)}>
          <I18nText>sensors.isConnected</I18nText>
        </th>
        <th className={clsx(classes.subType, classes.column)}>
          <I18nText>sensors.subType</I18nText>
        </th>
        <th className={clsx(classes.name, classes.column)}>
          <I18nText>sensors.name</I18nText>{" "}
          <BubbleHelp id="devices.edit.sensorName" />
        </th>
        <th className={clsx(classes.contentType, classes.column)}>
          <I18nText>sensors.contentType</I18nText>{" "}
          <BubbleHelp id="devices.edit.contentType" />
        </th>
        <th className={clsx(classes.capacity, classes.column)}>
          <I18nText>sensors.capacity</I18nText>{" "}
          <BubbleHelp id="devices.edit.capacity" />
        </th>
        <th className={clsx(classes.fillLimit, classes.column)}>
          <I18nText>sensors.fillLimit</I18nText>{" "}
          <BubbleHelp id="devices.edit.fillLimit" />
        </th>
        <th className={clsx(classes.threshold, classes.column)}>
          <I18nText>sensors.threshold</I18nText>{" "}
          <BubbleHelp id="devices.edit.threshold" />
        </th>
        {showTemperatureColumn && (
          <th className={clsx(classes.temperatureLimit, classes.column)}>
            <I18nText>sensors.temperatureLimitValue</I18nText>{" "}
            <BubbleHelp id="devices.edit.temperatureLimitValue" />
          </th>
        )}
      </tr>
    </thead>
  );
};

export default Header;
